import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ds from 'designsystem';

import { desktopBreakpoint, tabletBreakpoint } from 'common/responsive';

import { CardSlider as CardSliderModel } from 'models';
import Container from 'blocks/Container/Container';
import Carousel from 'blocks/Carousel/Carousel';
import Header4 from 'elements/Header4';
import { Row, Column } from 'hedron';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { safeHtmlWithBr } from 'common/methods/string';
import FeatureCard from './FeatureCard';
import CardWrapper from './CardWrapper';

const CardSlider = styled.div`
    width: 100%;
    margin: 0 auto;
    position: relative;
    height: 750px;
    padding: 0;
`;

export default class CardSliderBlock extends Component {
static carouselSettings = {
  swipe: true,
  slidesToShow: 4.856,
  dots: false,
  infinite: false,
  arrows: false,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1366,
      settings: {
        slidesToShow: 3.89,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        arrows: false,
      },
    },
    {
      breakpoint: desktopBreakpoint,
      settings: {
        slidesToShow: 2.12,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
      },
    },
    {
      breakpoint: tabletBreakpoint,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        arrows: false,
      },
    },
  ],
};

static propTypes = {
  data: PropTypes.instanceOf(CardSliderModel).isRequired,
}

render() {
  const {
    data: {
      slides,
      header,
      htmlModifiers,
    },
  } = this.props;

  return (
    <HTMLModifiableBackground
      htmlModifiers={htmlModifiers}
      color={ds.brand('background')}
    >
      <Container>
        <Row>
          <Column lg={12}>
            <CardSlider>
              <Header4
                bold
                dangerouslySetInnerHTML={{
                  __html: safeHtmlWithBr(header),
                }}
              />
              <CardWrapper>
                <Carousel
                  settings={CardSliderBlock.carouselSettings}
                >
                  {slides.map((slide, index) => (
                    <FeatureCard
                      featureCard={slide}
                      key={slide.system.id}
                      index={index}
                    />
                  ))
                  }
                </Carousel>
              </CardWrapper>
            </CardSlider>
          </Column>
        </Row>
      </Container>
    </HTMLModifiableBackground>
  );
}
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/CardSlider/index.jsx